import { Icon, Text } from '@dixa/lib-shared-habla';

import styles from './documentationLink.module.scss';

export function DocumentationLink(): JSX.Element {
  return (
    <Text.ExternalLink
      className={styles.root}
      href="https://messenger-docs.dixa.io"
      rel="noopener noreferrer"
      target="_blank"
    >
      <span>Read the developer documentation</span>{' '}
      <Icon name="external-link" />
    </Text.ExternalLink>
  );
}
